import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { generatePath } from "react-router-dom";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";
import SharedCaseService from "../../../services/Shared/shared.service";
import AdminCaseService from "../../../services/Case/AdminCase/adminCase.service";


const SharedPageRedirect = () => {
  const history = useHistory();
  const location = useLocation();
  const [labelText, setLabelText] = useState("Authenticating...");
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
  const isIOS = /iPad|iPhone|iPod/.test(ua);

  const handleGuestLogin = (caseDetailID: number, key: any) => {
    return new Promise<void>((resolve, reject) => {
      if (caseDetailID && key) {
        SharedCaseService.guestLogin(
          Number(caseDetailID),
          key,
          (token: string, downloadZip: boolean) => {
            try {
              localStorage.setItem("Authorization", token);
              localStorage.setItem("download_zip", downloadZip ? "true" : "false");
              resolve();
            } catch (error) {
              reject(error);
            }
          },
          () => {
            reject(new Error("Failed to log in"));
          },
          () => {
            reject(new Error("Failed to log in"));
          }
        );
      } else {
        reject(new Error("Invalid caseDetailID or key"));
      }
    });
  };

  const handleDownloadClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isIOS && pdfUrl) {
      e.preventDefault();
      window.location.href = "x-safari-" + pdfUrl;
    }
  };

  useEffect(() => {
    const processGuestLogin = async () => {
      const searchParams = new URLSearchParams(location.search);
      const fullQueryString = location.search.substring(1);

      const params: any = {};
      fullQueryString.split("&").forEach((param) => {
        const [key, value] = param.split("=");
        params[key] = decodeURIComponent(value).replace(/\?$/, "");
      });

      const key = params["key"] || searchParams.get("key");
      const caseId = params["case_id"] || searchParams.get("case_id");
      const report = params["report"] || searchParams.get("report");

      try {
        await handleGuestLogin(caseId, key);

        const token = localStorage.getItem("Authorization");
        if (token) {
          if (report === "true") {
            AdminCaseService.downloadAdminReport(
              caseId,
              (url: string) => {
                localStorage.clear();
                if (url) {
                  setPdfUrl(url);
                  setPdfLoading(true);
                  setTimeout(() => setPdfLoading(false), 3000);
                } else {
                  setError("No report found!");
                }
              },
              () => {
                setError("Failed to load report.");
              },
              () => {}
            );
          } else {
            history.push(
              generatePath(AppRoutes.CASE_DETAIL_GUEST, {
                caseId: caseId,
              })
            );
          }
        } else {
          history.replace("/auth/login");
        }
      } catch (error) {
        console.error("Error during guest login:", error);
        history.replace("/auth/login");
      }
    };

    processGuestLogin();
  }, [history, location]);

  if (pdfUrl) {
    const viewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(pdfUrl)}&embedded=true`;

    return (
      <div style={{ position: "fixed", inset: 0, display: "flex", flexDirection: "column", background: "#fff" }}>
        <div style={{ padding: "10px 16px", background: "#f5f5f5", borderBottom: "1px solid #ddd", display: "flex", justifyContent: "flex-end" }}>
          <a
            href={pdfUrl}
            onClick={handleDownloadClick}
            style={{ fontSize: 14, color: "#1a73e8", textDecoration: "none", fontWeight: 500 }}
          >
            {"Download PDF"}
          </a>
        </div>

        <div style={{ position: "relative", flex: 1 }}>
          {pdfLoading && (
            <div style={{
              position: "absolute", inset: 0,
              display: "flex", flexDirection: "column",
              alignItems: "center", justifyContent: "center",
              background: "#fff", zIndex: 1,
            }}>
              <div style={{
                width: 40, height: 40,
                border: "3px solid #e0e0e0",
                borderTop: "3px solid #1a73e8",
                borderRadius: "50%",
                animation: "spin 0.8s linear infinite",
              }} />
              <p style={{ marginTop: 12, color: "#666", fontSize: 14 }}>Loading report...</p>
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
          )}

          {isIOS ? (
            <object
              data={pdfUrl}
              type="application/pdf"
              style={{ width: "100%", height: "100%", border: "none", display: "block" }}
            >
              <div style={{ padding: 24, textAlign: "center" }}>
                <p style={{ marginBottom: 16, color: "#333" }}>Unable to display PDF inline.</p>
                <a
                  href={pdfUrl}
                  onClick={handleDownloadClick}
                  style={{ display: "inline-block", padding: "12px 24px", background: "#1a73e8", color: "#fff", borderRadius: 8, textDecoration: "none", fontWeight: 500 }}
                >
                  Open PDF
                </a>
              </div>
            </object>
          ) : (
            <iframe
              src={viewerUrl}
              style={{ width: "100%", height: "100%", border: "none", display: "block" }}
              title="Report"
              onLoad={() => setPdfLoading(false)}
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="spinner">{error ?? labelText}</div>
    </div>
  );
};

export default SharedPageRedirect;
